module.exports = __webpack_public_path__ + "img/book-trailer.a6c906df.webp";